var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pui-lightbox",
    {
      ref: _vm.REF_CONSTANTS.LIGHTBOX,
      attrs: {
        "on-confirm-callback": _vm.onLightboxConfirm,
        "default-footer-confirm-disabled": !_vm.isFormSubmittable,
        "default-footer-cancel-label": _vm.$t("emailTemplateModal.cancel"),
        "default-footer-confirm-label": _vm.$t(
          "emailTemplateModal.saveTemplate"
        ),
        "default-header-label": _vm.lightboxTitle,
      },
      on: { "puilightbox:close": _vm.onLightboxClose },
    },
    [
      _c(
        "pui-loader",
        { attrs: { promise: _vm.emailTemplatePromise } },
        [
          _c(
            "pui-form",
            {
              staticClass: "email-template__form",
              attrs: { "aria-label": "email-template-form" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.showEmailField
                ? _c(
                    "pui-form-group",
                    {
                      attrs: {
                        label: _vm.$t("emailTemplateModal.email"),
                        "is-valid": _vm.formData.email.isValid,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "error-message",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "emailTemplateModal.errorMessage.invalidEmail"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2673331430
                      ),
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          "is-valid": _vm.formData.email.isValid,
                          type: "email",
                        },
                        on: {
                          input: function (input) {
                            return _vm.validateField("email", input)
                          },
                        },
                        model: {
                          value: _vm.formData.email.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.email, "value", $$v)
                          },
                          expression: "formData.email.value",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "pui-form-group",
                {
                  attrs: {
                    label: _vm.$t("emailTemplateModal.subject"),
                    "is-valid": _vm.formData.subject.isValid,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "error-message",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "emailTemplateModal.errorMessage.required"
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("pui-form-input-field", {
                    attrs: { "is-valid": _vm.formData.subject.isValid },
                    on: {
                      input: function (input) {
                        return _vm.validateField("subject", input)
                      },
                    },
                    nativeOn: {
                      dragover: function ($event) {
                        return _vm.textFieldDragOver.apply(null, arguments)
                      },
                      drop: function ($event) {
                        return _vm.textFieldDrop(
                          $event,
                          _vm.handleDropForSubject
                        )
                      },
                    },
                    model: {
                      value: _vm.formData.subject.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.subject, "value", $$v)
                      },
                      expression: "formData.subject.value",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  attrs: {
                    label: _vm.$t("emailTemplateModal.body"),
                    "is-valid": _vm.formData.body.isValid,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "error-message",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "emailTemplateModal.errorMessage.required"
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("pui-form-textarea", {
                    attrs: {
                      "is-valid": _vm.formData.body.isValid,
                      grow: true,
                      rows: 8,
                    },
                    on: {
                      input: function (input) {
                        return _vm.validateField("body", input)
                      },
                    },
                    nativeOn: {
                      dragover: function ($event) {
                        return _vm.textFieldDragOver.apply(null, arguments)
                      },
                      drop: function ($event) {
                        return _vm.textFieldDrop($event, _vm.handleDropForBody)
                      },
                    },
                    model: {
                      value: _vm.formData.body.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.body, "value", $$v)
                      },
                      expression: "formData.body.value",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                { attrs: { label: _vm.$t("emailTemplateModal.tags") } },
                [
                  _c(
                    "div",
                    { staticClass: "email-template__form__tag-list" },
                    _vm._l(_vm.emailTemplateTags, function (tag) {
                      return _c("pui-chip", {
                        key: tag.txtModuleSid,
                        attrs: {
                          draggable: true,
                          "border-color": _vm.CHIP_BORDER_COLOR,
                          label: tag.txtModule,
                        },
                        nativeOn: {
                          dragstart: function ($event) {
                            return _vm.tagDragStart($event, tag.txtModule)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }